import { Card, CardContent, Grid, Typography } from "@mui/material";
import COLORS from "../../utils/colorsStatus";
import type { StatusText } from "../../utils/statusText";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PackageOpenIcon from "../../constants/icons/package-open";
import CheckIcon from "../../constants/icons/check";
import PackageClose from "../../constants/icons/package-close";
import PeopleIcon from "../../constants/icons/people";

interface CardStatisticProp {
  title: string;
  count: number;
  onClick?: () => void;
  colors?: [string, string];
}

export default function CardStatistic({ title, count, onClick, colors }: CardStatisticProp) {
  // Si se proporcionan colores, usarlos; si no, usar los colores hardcodeados por compatibilidad
  const [color1, color2] = colors || (title in COLORS ? COLORS[title as StatusText] : ["#939c9fab", "#4a4a4a"]);
  return (
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <Card
        onClick={onClick}
        sx={{
          background: `linear-gradient(180deg, ${color1}, ${color2})`,
          color: "#fff",
          width: "95%",
          margin: "0 auto",
          minHeight: 100,
          cursor: onClick ? "pointer" : "default",
          transition: "transform 0.2s, box-shadow 0.2s",
          "&:hover": onClick
            ? {
                transform: "translateY(-2px)",
                boxShadow: 4,
              }
            : {},
        }}
      >
        <CardContent sx={{ position: "relative" }}>
          <Typography variant="h2" fontWeight={700}>
            {count}
          </Typography>
          <Typography fontSize={14} fontWeight={700}>
            {title}
          </Typography>
          <Icon title={title} />
        </CardContent>
      </Card>
    </Grid>
  );
}

const Icon = ({ title }: { title: string }) => {
  // Mapeo flexible para títulos dinámicos
  const titleLower = title.toLowerCase();
  if (titleLower.includes("tránsito") || titleLower.includes("transito")) {
      return (
        <div
          style={{
            position: "absolute",
            right: -15,
            bottom: -30,
            opacity: 0.25,
          }}
        >
          <LocalShippingIcon sx={{ fontSize: 140 }} />
        </div>
      );
  }
  
  if (titleLower.includes("entregado")) {
    return (
      <div
        style={{
          position: "absolute",
          right: -25,
          bottom: -30,
          opacity: 0.25,
        }}
      >
        <CheckIcon />
      </div>
    );
  }
  
  if (titleLower.includes("listo") || titleLower.includes("retirar")) {
    return (
      <div
        style={{
          position: "absolute",
          right: -25,
          bottom: -30,
          opacity: 0.25,
        }}
      >
        <PackageClose />
      </div>
    );
  }
  
  if (titleLower.includes("recibido")) {
    return (
      <div
        style={{
          position: "absolute",
          right: -25,
          bottom: -30,
          opacity: 0.25,
        }}
      >
        <PackageOpenIcon />
      </div>
    );
  }
  
  if (titleLower.includes("usuario") || titleLower.includes("registrado")) {
    return (
      <div style={{ position: "absolute", right: -25, bottom: -30, opacity: 0.25 }}>
        <PeopleIcon />
      </div>
    );
  }
  
  // Icono por defecto
  return (
    <div
      style={{
        position: "absolute",
        right: -25,
        bottom: -30,
        opacity: 0.25,
      }}
    >
      <PackageOpenIcon />
    </div>
  );
};
